import styled from "styled-components";
import { Colors } from "styles/app-styles"
import Isvg from "react-inlinesvg"

interface CalcStateProps {
  calculated?: any,
  calcWarnings?: any,
  inProgress?: any,
  notCalc?: any,
  notCalcError?: any
}

export const CalcCancel_s = styled(Isvg)`
  border-radius: 50%;
  display: ${props => props.inProgress ? "block" : "none"};
  background-color: ${Colors.colorDanger};
  height: 12px !important;
  margin: -25px 0 0 12px;
  overflow: hidden;
  position: absolute;
  width: 12px !important;
  g > g { fill: ${Colors.white}; }
`

export const CalcIcon_s = styled(Isvg)<CalcStateProps>`
  cursor: pointer;
  path { fill: ${props => {
    if (props.calcWarnings){
      return `${Colors.colorWarning}`
    } else if (props.notCalcError){
      return `${Colors.colorDanger}`
    } else if (props.calcDanger){
      return `${Colors.colorDanger}`
    } else if (props.inProgress){
      return `${Colors.white}`
    } else {
      return `${Colors.blackPearl}`
    }
  }}}
`

export const CalcProgressBar_s = styled.div`
  background-color: ${Colors.white};
  border-radius: 10px;
  cursor: pointer;
  height: 6px;
  margin: 4px 0 0 6px;
`

export const CalcStateIcon = styled.div<CalcStateProps>`
  background: ${props => {
    if (props.notCalc){
      return `${Colors.blackPearl}`
    } else if (props.notCalcError){
      return `${Colors.colorDanger}`
    } else if (props.calcWarnings){
      return `${Colors.colorWarning}`
    } else if (props.calculated) {
      return `${Colors.colorSuccess}`
    } else if (props.inProgress){
      return `${Colors.periwinkleGrey}`
    } else {
      return `none`
    }
  }};
  border-radius: 2px;
  color: ${Colors.white} !important;
  font-size: 14px;
  padding: 3px 8px;
`;

export const CalcValidationIcon_s = styled.div<CalcStateProps>`
  margin-left: 8px;
  span.fa {
    color: ${props => props.calcWarnings ? `${Colors.colorWarning}` : `${Colors.colorDanger}`};
    cursor: pointer;
    font-size: 22px;
  }
`

export const CalcButton_s = styled.div`
  display: flex;
  height: 100% !important;
  margin: 0 !important;
  padding-left: 4px;
`

export const FolderCalcProgress = styled.div`
  height: 32px;
  margin-left: 5px;
  margin-top: 3px;
  display: inline-block;

  span {
    font-family: "Roboto",sans-serif;
    font-weight: 300;
    font-size: 12px;
    margin-left: 5px;
  }
`

export const FolderCalcState: any = styled.div<CalcStateProps>`
  background-color: ${props => {
    if (props.notCalcError){
      return `${Colors.inputErrorOpaque}`
    } else if (props.calcWarnings){
      return `${Colors.inputWarning}`
    } else if (props.inProgress){
      return `${Colors.periwinkleGrey}`
    } else {
      return `${Colors.white}`
    }
  }};
  color: ${Colors.white};
  cursor: pointer;
  height: 100%;
  margin-left: -34px;
  padding: 6px 6px 6px 30px;
  width: 200px;
`

export const FolderCalcStateIcon: any = styled(CalcStateIcon)`
  font-family: "Roboto", sans-serif;
  font-weight: 300;
`

export const PropertyCalcState_s = styled.div<CalcStateProps>`
  align-items: center;
  background-color: ${props => {
    if (props.notCalcError){
      return `${Colors.inputError}`
    } else if (props.calcWarnings){
      return `${Colors.inputWarning}`
    } else if (props.inProgress){
      return `${Colors.periwinkleGrey}`
    } else {
      return `${Colors.white}`
    }
  }};
  color: ${Colors.white};
  display: flex;
  height: 50px;
  ${props => { if (props.calcWarnings || props.inProgress)
    return `
      margin-left: -15px;
      padding-left: 15px;
    `
  }}
  padding: 0 8px 0 8px;
`;

export const PropertyCalcStateIcon_s = styled(CalcStateIcon)`
  margin-left: 8px;
  ${props => props.inProgress && `margin-top: 8px; padding: 0 8px 0 15px;`}
`

export const StyledFolderCalcIcon = styled(Isvg)`
  .cls-1 {
    fill: ${Colors.colorDanger} !important;
  }

`

export const FolderCalcIconWrapper = styled(Isvg)`

`
